(function(){
  /* ------------------------------------------------------------------
     ONE shared script for every ALUMA advertorial.

     Two modes:
       legacy  - the pages that exist today. 3 bundles, one-time OR Seal
                 subscription toggle, two ₪0 gift accessories. Untouched.
       sub99   - the subscription-only test (Sept 2026). Enabled ONLY when
                 the page template placed the "ALUMA sub-only offer" config
                 section BEFORE the advertorial section, which defines
                 window.ALUMA_OFFER. Old pages never define it, so they
                 keep running the legacy branch byte-for-byte.

     sub99 rules (from Itay, 2026-09-04):
       - 1 bag ₪99 / 2 bags ₪189, no 3-bag tier
       - no gift accessories
       - subscription only - no toggle, just small print under the picker
       - one small link "לרכישה ללא מנוי במחיר מלא" -> the original page
     The selling-plan ids + real per-delivery prices are READ from the sub
     product's own /products/<handle>.js at load, so Seal can be changed
     without touching this file. The config numbers are only a fallback
     for the first paint before that fetch resolves.
     ------------------------------------------------------------------ */
  var OFFER = window.ALUMA_OFFER || null;
  var SUB99 = !!(OFFER && OFFER.mode === 'sub99');

  /* Seal Subscriptions plans, read back from the live store. These `unit`
     numbers are FIXED PRICES set inside Seal - the page only mirrors them.
     If they drift, the card price and the checkout price disagree and she
     bounces at payment. Never edit one side alone.

     2026-08-03: Seal moved from 15% to 10%. Units updated to match:
     161.40->170.91, 118.95->125.95, 96.30->101.97. Everything downstream
     (card price, saving, headline %, topbar claim) derives from these. */
  var SUB = {
    1: { plan: 691750076708, unit: 170.91 },   // ships monthly
    2: { plan: 691750240548, unit: 125.95 },   // ships every 2 months
    3: { plan: 691750273316, unit: 101.97 }    // ships every 3 months
  };
  var B = {
    1: { price:189.90, compare:249.90 },
    2: { price:279.90, compare:499.80 },
    3: { price:339.90, compare:749.70 }
  };
  /* The "+ אקססוריז מתנה" the cards promise. Both ₪0.00, one of each per
     order regardless of bundle size, and deliberately WITHOUT a selling_plan -
     a subscriber needs one spoon, not a new one every month. Verified they do
     not push the cart up an automatic quantity-discount bracket. */
  var GIFTS = [
    { id: 52787697156388, quantity: 1 },   // כפית מדידה Aluma
    { id: 52787696763172, quantity: 1 }    // מקציף חלב Aluma
  ];
  var COPY = {
    on:  { t: 'משלוח עד הבית חינם 🚚', s: 'מנוי מתחדש · בלי התחייבות · ביטול בכל עת' },
    off: { t: 'משלוח לנקודת איסוף',     s: 'רכישה חד־פעמית, בלי מנוי' }
  };

  if(SUB99){
    /* Rebuild the two tables from the config. `unit` is per bag, so tier 2
       at ₪189 is ₪94.50 a bag - what Seal's 2-month rule must charge. */
    var T = OFFER.tiers || {};
    SUB = {}; B = {};
    Object.keys(T).forEach(function(k){
      var q = parseInt(k,10), t = T[k];
      SUB[q] = { plan: t.plan || null, unit: t.price / q };
      B[q]   = { price: t.price, compare: t.compare || (OFFER.unit_compare || 249.90) * q };
    });
    GIFTS = [];
  }

  var H = {'Content-Type':'application/json'};
  var root = document.getElementById('av-bundles');
  if(!root) return;
  var cards    = Array.prototype.slice.call(root.querySelectorAll('.av-bundle'));
  var orderBtn = document.getElementById('av-orderbtn');
  var subrow   = document.getElementById('av-subrow');
  var subTitle = subrow.querySelector('.av-st');
  var subDesc  = subrow.querySelector('.av-sd');
  var subOn    = true;
  var busy     = false;   // one checkout chain at a time
  var addedOnce = false;  // whether THIS page load already put items in the cart
  /* Hebrew has no neutral second person, so the saving line has to be gendered.
     The women's pages say חסכי and leave the attribute off; the men's page sets
     data-save="חסכת" on #av-bundles. Reading it here keeps ONE shared file
     serving every advertorial instead of forking the script per audience. */
  var saveVerb = root.getAttribute('data-save') || 'חסכי';
  var shipChip = (function(){
    var chips = document.querySelectorAll('.av-trustline span');
    for(var i=0;i<chips.length;i++){
      if(chips[i].textContent.indexOf('משלוח') > -1) return chips[i];
    }
    return null;
  })();
  var ils = function(n){
    return '₪' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  /* ---- sub99: reshape the markup the section shipped -------------------
     The advertorial sections are shared with the legacy pages, so the
     3-card / gift-line HTML arrives as-is and is trimmed here. */
  if(SUB99){
    cards = cards.filter(function(card){
      var q = parseInt(card.getAttribute('data-qty'),10);
      if(B[q]) return true;
      card.parentNode.removeChild(card);
      return false;
    });
    /* nothing selected any more (tier 3 was the default on some pages)?
       fall back to the biggest remaining bundle */
    if(!cards.some(function(c){ return c.classList.contains('av-is-sel'); }) && cards.length){
      cards[cards.length-1].classList.add('av-is-sel');
    }
    Array.prototype.slice.call(root.querySelectorAll('.av-gift')).forEach(function(g){
      g.parentNode.removeChild(g);
    });
    /* header wording comes from the config ("שקית אחת בחודש" / "2 שקיות בחודש") -
       the shipped markup says חודשיים / דו־חודשי, which is no longer true */
    cards.forEach(function(card){
      var q = parseInt(card.getAttribute('data-qty'),10);
      var hdr = card.querySelector('.av-hdr');
      var lbl = OFFER.labels && OFFER.labels[q];
      if(hdr && lbl){
        var small = hdr.querySelector('small');
        hdr.textContent = '';
        hdr.appendChild(document.createTextNode(lbl));
        if(small) hdr.appendChild(small); else hdr.appendChild(document.createElement('small'));
      }
      var img = card.querySelector('.av-pic img');
      if(img && lbl) img.alt = lbl;
    });
    root.style.setProperty('grid-template-columns', 'repeat(' + cards.length + ',1fr)', 'important');
    root.style.setProperty('max-width', cards.length === 2 ? '640px' : '', 'important');
    root.style.setProperty('margin', '0 auto', 'important');
    /* the picker row becomes a non-interactive note - subscription is the
       only way to buy on this page, there is nothing to toggle */
    subrow.classList.add('av-on', 'av-subnote');
    subrow.removeAttribute('role');
    subrow.removeAttribute('tabindex');
    subrow.setAttribute('aria-hidden', 'false');
    subrow.style.cursor = 'default';
    /* the note moves from above the cards to right under the order button
       (Itay 2026-09-05), and the small full-price link goes under the note */
    if(orderBtn){
      orderBtn.parentNode.insertBefore(subrow, orderBtn.nextSibling);
      if(OFFER.full_url){
        var a = document.createElement('a');
        a.className = 'av-fullprice';
        a.href = OFFER.full_url;
        a.textContent = OFFER.link_text || 'לרכישה ללא מנוי במחיר מלא';
        subrow.parentNode.insertBefore(a, subrow.nextSibling);
      }
    }
  }

  /* ---- legacy pages: new tier names (Itay 2026-09-15) -------------------
     The section HTML still says חודש אחד / חודשיים / שלושה חודשים (or the
     מארז חודשי variants). Every tier now ships MONTHLY, so the names describe
     the pack size instead: מארז יחיד / כפול / משולש. Rewritten here so the 7
     section files stay untouched. The % line inside <small> is kept. */
  var LEGACY_LABELS = { 1: 'מארז יחיד', 2: 'מארז כפול', 3: 'מארז משולש' };
  if(!SUB99){
    cards.forEach(function(card){
      var q = parseInt(card.getAttribute('data-qty'),10);
      var hdr = card.querySelector('.av-hdr');
      var lbl = LEGACY_LABELS[q];
      if(hdr && lbl){
        var small = hdr.querySelector('small');
        hdr.textContent = '';
        hdr.appendChild(document.createTextNode(lbl));
        if(small) hdr.appendChild(small); else hdr.appendChild(document.createElement('small'));
      }
      var img = card.querySelector('.av-pic img');
      if(img && lbl) img.alt = lbl;
    });
  }

  /* ---- Bundle selection ------------------------------------------------
     Painted as INLINE STYLE, and with NO transition. Both are deliberate.

     aluma-adv.css ships unselected cards at #6B4A36 and selected at #7B3D28 -
     two dark browns three shades apart, so which bundle was chosen was nearly
     invisible. Fixing it from an injected <style> lost twice: the sections
     link aluma-adv.css from the BODY, so it outranks anything appended to
     <head>. Inline style sits above all of it.

     And no transition, because a transitioned property here gets stuck at its
     pre-transition value - border-color and opacity kept reporting the state
     from the PREVIOUS selection while transform and the header updated fine.
     Dropping the transition made both apply instantly and correctly. An
     instant switch is right for a picker anyway; there is nothing to animate.

     Five signals change at once so the choice reads at a glance: border colour
     AND weight, opacity, elevation, header darkness, and a tick.
     -------------------------------------------------------------------- */
  function paint(card, on){
    card.style.removeProperty('transition');
    card.style.setProperty('border-color', on ? '#7B3D28' : '#DED2C2', 'important');
    card.style.setProperty('opacity',      on ? '1' : '0.58',          'important');
    card.style.setProperty('transform',    on ? 'translateY(-7px)' : 'none', 'important');
    card.style.setProperty('box-shadow',   on ? '0 14px 32px rgba(123,61,40,.42)' : 'none', 'important');
    if(on) card.style.setProperty('border-width', '4px', 'important');
    else   card.style.removeProperty('border-width');
    var hdr = card.querySelector('.av-hdr');
    if(hdr){
      hdr.style.setProperty('background', on ? '#3E2A1F' : '#A28D78', 'important');
      var tick = hdr.querySelector('.av-tick');
      if(on && !tick){
        tick = document.createElement('span');
        tick.className = 'av-tick';
        tick.textContent = '✓ ';
        hdr.insertBefore(tick, hdr.firstChild);
      } else if(!on && tick){
        tick.parentNode.removeChild(tick);
      }
    }
    var badge = card.querySelector('.av-badge');
    if(badge) badge.style.setProperty('background', on ? '#7B3D28' : '#A28D78', 'important');
  }
  function injectStyles(){
    var st = document.createElement('style');
    st.textContent =
      '.aluma-adv .av-deadline b{direction:ltr;unicode-bidi:isolate;display:inline-block;' +
      'font-variant-numeric:tabular-nums;font-weight:800;letter-spacing:.5px}';
    document.head.appendChild(st);
  }
  function selectedQty(){
    var card = root.querySelector('.av-bundle.av-is-sel');
    return card ? parseInt(card.getAttribute('data-qty'),10) : 1;
  }
  /* sub99 small print. Three ticked lines, RYZE-style, that re-read for the
     bundle she has selected: the price and the next-shipment date change,
     the cancel line does not. */
  function renderSubNote(){
    var q = selectedQty();
    var t = OFFER.tiers[q] || OFFER.tiers[1];
    var months = 30;   // every bundle ships monthly - 2 bags = 2 bags a month
    var lines = (OFFER.lines || []).map(function(l){
      return l.replace('{price}', ils(SUB[q].unit * q).replace('.00',''))
              .replace('{days}', String(months))
              .replace('{qty}', String(q));
    });
    subrow.innerHTML = lines.map(function(l){
      return '<div class="av-subline"><span class="av-chk" aria-hidden="true">' +
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
        '</span><span class="av-sl">' + l + '</span></div>';
    }).join('');
    if(shipChip) shipChip.textContent = '🚚 משלוח עד הבית חינם';
    void t;
  }
  function render(){
    cards.forEach(function(card){
      var qty = parseInt(card.getAttribute('data-qty'),10);
      var b   = B[qty]; if(!b) return;
      var now = subOn ? SUB[qty].unit * qty : b.price;
      card.querySelector('.av-now').textContent  = ils(now);
      card.querySelector('.av-was').textContent  = ils(b.compare);
      card.querySelector('.av-save').textContent = saveVerb + ' ' + ils(b.compare - now);
      /* headline % is derived, never hand-typed - it has to survive the toggle */
      card.querySelector('.av-hdr small').textContent =
        Math.round((1 - now / b.compare) * 100) + '% הנחה';
    });
    if(SUB99){ renderSubNote(); return; }
    /* Itay 2026-10-16: the row text never changes - unticked just means she is not taking it */
    var c = COPY.on;
    subTitle.textContent = c.t;
    subDesc.textContent  = c.s;
    if(shipChip) shipChip.textContent = subOn ? '🚚 משלוח עד הבית חינם' : '📦 משלוח לנקודת איסוף';
    subrow.classList.toggle('av-on', subOn);
    subrow.setAttribute('aria-checked', subOn ? 'true' : 'false');
  }
  /* The topbar and CTAs quote a best-case discount. Derived from the same table
     that prices the cards so the claim cannot drift from what checkout charges. */
  function syncMaxClaim(){
    var best = 0;
    Object.keys(SUB).forEach(function(k){
      var q = parseInt(k,10);
      var d = 1 - (SUB[q].unit * q) / B[q].compare;
      if(d > best) best = d;
    });
    var pct = Math.round(best * 100) + '%';
    document.querySelectorAll('.aluma-adv .av-topbar b, .aluma-adv .av-cta, .av-sticky-claim')
      .forEach(function(el){
        el.innerHTML = el.innerHTML.replace(/\d+%/g, pct);
      });
  }
  function select(card){
    cards.forEach(function(c){
      var on = (c === card);
      c.classList.toggle('av-is-sel', on);
      c.setAttribute('aria-selected', on ? 'true' : 'false');
      paint(c, on);
    });
    if(SUB99) renderSubNote();
  }
  cards.forEach(function(card){
    card.addEventListener('click', function(e){
      if(e.target.closest('select')) return;
      select(card);
      if(e.target.closest('.av-atc')) checkout();
    });
  });
  function toggleSub(){ subOn = !subOn; render(); }
  if(!SUB99){
    subrow.addEventListener('click', toggleSub);
    subrow.addEventListener('keydown', function(e){
      if(e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); toggleSub(); }
    });
  }
  /* Counts to 23:59:59 in HER timezone, which is what every CTA already
     promises. Digits are isolated LTR - a bare HH:MM:SS inside RTL reorders. */
  function startCountdown(){
    var el = document.querySelector('.av-deadline');
    if(!el) return;
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function tick(){
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      var s   = Math.max(0, Math.floor((end - now) / 1000));
      el.innerHTML = 'ההנחה שלך נשמרת עוד <b>' +
        pad(Math.floor(s / 3600)) + ':' +
        pad(Math.floor((s % 3600) / 60)) + ':' +
        pad(s % 60) + '</b>';
    }
    tick();
    setInterval(tick, 1000);
  }
  function clearCart(){ return fetch('/cart/clear.js', {method:'POST', headers:H}); }
  /* `sections` makes the add answer with the freshly rendered cart drawer, so
     the drawer can open on the new cart without a second request. */
  function addItems(items){
    var body = {items:items};
    if(drawer()){
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', {
      method:'POST', headers:H, body:JSON.stringify(body)
    });
  }
  /* ---- Why the cart flow is more careful than it looks -----------------
     Shopify runs a bot filter in front of the cart endpoints. It counts POSTs,
     and once tripped it answers 429/430 with a "Verifying your connection"
     HTML page instead of JSON. The old flow fired clear+add on EVERY click,
     so a shopper who clicked twice - or tapped once on a slow phone and tapped
     again - burned four POSTs and got a generic error alert on a working cart.

     Three changes:
       1. `busy` guard, so a double tap cannot start a second chain.
       2. Clear only when it is actually needed. On a landing page arrived at
          from an ad the cart is nearly always empty, and a GET /cart.js is not
          on the throttled path - so the common case is now ONE POST, not two.
       3. A throttled add waits and retries instead of surfacing as an error.
     -------------------------------------------------------------------- */
  function ensureEmpty(){
    if(addedOnce) return clearCart();
    return fetch('/cart.js', {headers:H})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(c){ return (c && c.item_count > 0) ? clearCart() : null; })
      .catch(function(){ return null; });
  }
  function addWithRetry(items, tries){
    return addItems(items).then(function(r){
      if(r.ok) return r;
      if((r.status === 429 || r.status === 430) && tries > 0){
        return new Promise(function(res){ setTimeout(res, 1600); })
          .then(function(){ return addWithRetry(items, tries - 1); });
      }
      return r;
    });
  }
  /* ---- Cart drawer instead of /checkout (Itay 2026-10-16) ----------------
     The order button used to build the cart silently and jump to /checkout.
     Now it opens Shrine's own cart drawer, so the shopper sees the bundle,
     the gifts and the drawer upsells (mug, takeaway cup, shipping insurance)
     before paying. Upsells are managed in the theme customizer
     (Cart drawer -> Upsells) - nothing about them lives in this file.

     Upsells ticked by default in the customizer (today: the ₪12 insurance)
     are added with the bundle, because the drawer only SHOWS a ticked toggle,
     it does not add it. Reading data-selected at click time also keeps the
     shopper's own toggles if she closes the drawer and orders again.

     If the drawer is missing or the add did not return its HTML, fall back to
     the old jump to /checkout so a sale is never lost to this. */
  function drawer(){
    var d = document.querySelector('cart-drawer');
    return (d && typeof d.renderContents === 'function' && typeof d.open === 'function') ? d : null;
  }
  function preselectedUpsells(){
    var out = [];
    document.querySelectorAll('cart-drawer-upsell[data-selected="true"]').forEach(function(u){
      var id = parseInt(u.getAttribute('data-id'), 10);
      if(id) out.push(id === 52660913176868 ? { id: id, quantity: 1, selling_plan: 692467138852 } : { id: id, quantity: 1 });
    });
    return out;
  }
  function openDrawer(json){
    var d = drawer();
    if(!d || !json || !json.sections) return false;
    try{
      d.classList.remove('is-empty');
      d.renderContents(json);
      return true;
    }catch(e){ return false; }
  }
  function checkout(){
    if(busy) return;
    var card = root.querySelector('.av-bundle.av-is-sel');
    if(!card){ alert('בחר חבילה'); return; }
    var qty  = parseInt(card.getAttribute('data-qty'),10);
    var plan = subOn ? SUB[qty].plan : null;
    if(SUB99 && !plan){
      /* Seal rule for this bundle is not attached to the sub product yet.
         Refuse rather than silently sell a one-time bag at full price. */
      alert('המנוי לחבילה הזו עדיין לא פעיל. נסי שוב בעוד רגע.');
      return;
    }
    var items = [];
    card.querySelectorAll('select').forEach(function(s){
      var it = { id: parseInt(s.value,10), quantity: 1 };
      if(plan) it.selling_plan = plan;
      items.push(it);
    });
    var extras = preselectedUpsells();
    busy = true;
    var label = orderBtn.textContent;
    orderBtn.disabled = true;
    orderBtn.textContent = 'מוסיפים לסל...';
    function reset(){
      busy = false;
      orderBtn.disabled = false;
      orderBtn.textContent = label;
    }
    ensureEmpty()
      .then(function(){ return addWithRetry(items.concat(GIFTS, extras), 2); })
      .then(function(r){
        if(r.ok) return r;
        /* Both gifts are stock-tracked with DENY. If they run dry the add 422s,
           and without this a freebie would take the whole sale with it. */
        return addWithRetry(items, 1);
      })
      .then(function(r){ if(!r.ok) throw new Error('add failed ' + r.status); return r.json(); })
      .then(function(json){
        addedOnce = true;
        if(openDrawer(json)){
          reset();
          window.dispatchEvent(new Event('scroll'));   // sticky bar re-checks now
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function(){
        reset();
        alert('רגע אחד ונסה שוב');
      });
  }
  orderBtn.addEventListener('click', checkout);

  /* ---- Keep the subscription tier in step with the bag count -------------
     (Itay 2026-10-16) Each Seal plan is a FIXED per-bag price for one tier,
     and a cart line keeps the plan it was added with. So a shopper who added
     the double pack and pressed minus in the drawer was left with ONE bag at
     the double-pack price (₪139.95 instead of ₪189.90). One-time lines need
     nothing - the automatic quantity discount already re-prices them.

     After every drawer change (Shrine publishes cartUpdate), count the bags
     on this page's subscription plans and move every such line to the plan
     for that count: 1 -> tier 1, 2 -> tier 2, 3+ -> top tier (sub99: 1 / 2+).
     It works upwards too: going from 1 bag to 3 earns the triple-pack price.
     Lines on any other plan (e.g. the 1+1 offer) are never touched. */
  function ladder(){
    var out = [];
    Object.keys(SUB).map(function(k){ return parseInt(k,10); })
      .sort(function(a, b){ return a - b; })
      .forEach(function(q){
        var p = SUB[q] && SUB[q].plan;
        if(p && out.indexOf(p) === -1) out.push(p);
      });
    return out;
  }
  var retiering = false, retierAgain = false;
  function retier(){
    if(retiering){ retierAgain = true; return; }
    var plans = ladder();
    if(!plans.length) return;
    retiering = true;
    fetch('/cart.js', {headers:H})
      .then(function(r){ return r.json(); })
      .then(function(c){
        var lines = c.items.filter(function(i){
          var sp = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan;
          return sp && plans.indexOf(sp.id) > -1;
        });
        var total = lines.reduce(function(s, i){ return s + i.quantity; }, 0);
        if(!total) return false;
        var target = plans[Math.min(total, plans.length) - 1];
        var todo = lines.filter(function(i){
          return i.selling_plan_allocation.selling_plan.id !== target;
        });
        /* one line at a time - parallel cart writes trip the bot filter */
        return todo.reduce(function(p, i){
          return p.then(function(){
            return fetch('/cart/change.js', {
              method:'POST', headers:H,
              body:JSON.stringify({ id: i.key, quantity: i.quantity, selling_plan: target })
            });
          });
        }, Promise.resolve()).then(function(){ return todo.length > 0; });
      })
      .then(function(changed){
        var d = drawer();
        if(!changed || !d) return;
        return fetch('/?sections=cart-drawer,cart-icon-bubble')
          .then(function(r){ return r.json(); })
          .then(function(s){ d.renderContents({ sections: s }); });
      })
      .catch(function(){})
      .then(function(){
        retiering = false;
        if(retierAgain){ retierAgain = false; retier(); }
      });
  }
  /* subscribe / PUB_SUB_EVENTS come from the theme's main.js, which is
     DEFERRED - this script runs before it, so hook in at DOMContentLoaded
     (deferred scripts have run by then). PUB_SUB_EVENTS is a top-level
     const, NOT a window property, so it is referenced bare. */
  function hookCartUpdates(){
    if(typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'){
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(){ retier(); });
    }
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', hookCartUpdates);
  } else {
    hookCartUpdates();
  }

  /* ---- Sticky order bar (Itay 2026-10-16) --------------------------------
     A slim bar pinned to the bottom while she reads. It does not add to cart
     itself - it scrolls to the bundle cards, where the choice is made. Hidden
     at the top of the page, while the cards are on screen, and while the cart
     drawer is open. Plain scroll listener + getBoundingClientRect on purpose:
     IntersectionObserver / rAF do not run in a hidden document. The % is
     filled by syncMaxClaim() from the same table as the topbar. */
  function stickyBar(){
    if(document.getElementById('av-sticky')) return;
    var st = document.createElement('style');
    st.textContent =
      '#av-sticky{position:fixed;left:0;right:0;bottom:0;z-index:99;direction:rtl;' +
      'display:flex;align-items:center;justify-content:space-between;gap:10px;' +
      'padding:10px 16px calc(10px + env(safe-area-inset-bottom));background:#FBF6EF;' +
      'border-top:1px solid #DED2C2;box-shadow:0 -6px 18px rgba(62,42,31,.14);' +
      'transform:translateY(110%);transition:transform .25s ease;font-family:inherit}' +
      '#av-sticky.av-show{transform:none}' +
      '#av-sticky .av-sticky-claim{font-size:14px;line-height:1.3;color:#3E2A1F}' +
      '#av-sticky .av-sticky-claim b{color:#7B3D28;font-weight:800}' +
      '#av-sticky button{flex:0 0 auto;border:0;border-radius:999px;background:#7B3D28;color:#fff;' +
      'font:inherit;font-size:16px;font-weight:800;padding:12px 22px;cursor:pointer}' +
      '@media (min-width:750px){#av-sticky{justify-content:center;gap:24px}}' +
      /* the WhatsApp bubble sits 55px from the bottom - lift it over the bar */
      'html.av-sticky-on #carthike-chat-button-container{bottom:92px!important}' +
      /* ...and hide it while the drawer is open, it covers the total row */
      'html.av-drawer-on #carthike-chat-button-container{display:none!important}';
    document.head.appendChild(st);
    var bar = document.createElement('div');
    bar.id = 'av-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="av-sticky-claim">עד <b>50%</b> הנחה היום<br>החזר כספי מלא תוך 30 יום</div>' +
      '<button type="button">הזמינו עכשיו</button>';
    document.body.appendChild(bar);
    bar.querySelector('button').addEventListener('click', function(){
      var top = root.getBoundingClientRect().top + window.pageYOffset - 70;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
    function update(){
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight;
      var cardsInView = r.top < vh * 0.85 && r.bottom > 80;
      var d = document.querySelector('cart-drawer');
      var drawerOpen = d && d.classList.contains('active');
      var show = window.pageYOffset > vh * 0.6 && !cardsInView && !drawerOpen;
      bar.classList.toggle('av-show', show);
      document.documentElement.classList.toggle('av-sticky-on', show);
      document.documentElement.classList.toggle('av-drawer-on', !!drawerOpen);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    setInterval(update, 800);   // catches the drawer opening/closing
    update();
  }

  /* ---- sub99: bind the cards to the SUB product ------------------------
     The section HTML carries the legacy product's variant ids in every
     <select>. Swap them for the sub product's variants (matched by flavour
     name), and pull the selling plans Seal attached to it. BOTH plans are
     monthly; they differ only in the fixed per-bag price - the dearer one
     (₪99) prices the 1-bag card, the cheaper one (₪94.50) the 2-bag card.
     With a single plan attached, both cards use it. Prices come from
     per_delivery_price so a Seal edit shows up here with no code change. */
  function bindSubProduct(){
    if(!OFFER.product) return;
    var norm = function(s){ return String(s).replace(/[’'׳`]/g, '').replace(/\s+/g,'').trim(); };
    fetch('/products/' + OFFER.product + '.js', {headers:H})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if(!p) return;
        var byTitle = {};
        p.variants.forEach(function(v){ byTitle[norm(v.title)] = v; });
        root.querySelectorAll('select option').forEach(function(o){
          var v = byTitle[norm(o.textContent)];
          if(v) o.value = v.id;
        });
        var alloc = ((p.variants[0] && p.variants[0].selling_plan_allocations) || [])
          .filter(function(a){ return a.per_delivery_price; })
          .sort(function(a, b){ return b.per_delivery_price - a.per_delivery_price; });
        if(alloc.length){
          var hi = alloc[0], lo = alloc[alloc.length - 1];
          if(SUB[1]){ SUB[1].plan = hi.selling_plan_id; SUB[1].unit = hi.per_delivery_price / 100; }
          if(SUB[2]){ SUB[2].plan = lo.selling_plan_id; SUB[2].unit = lo.per_delivery_price / 100; }
        }
        render();
        syncMaxClaim();
      })
      .catch(function(){});
  }

  /* ---- legacy pages: adopt the MONTHLY Seal rules --------------------------
     2026-09-15: every tier ships monthly. The rules are shared by all four
     products, so mushroom-coffee.js is a fine source for every page. Only
     plans whose delivery option reads "לחודש"/"חודש" (not חודשיים / 3) count;
     if exactly three exist they price tiers 1-3 by per-bag price, dearest
     first. Anything else (rules not created yet, old rules still attached
     alongside) leaves the hardcoded table alone, so nothing breaks mid-change.
     The table below MUST still be updated once the new rules are final. */
  function bindLegacyPlans(){
    fetch('/products/mushroom-coffee.js', {headers:H})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if(!p || !p.variants || !p.variants[0]) return;
        var monthly = {};
        (p.selling_plan_groups || []).forEach(function(g){
          (g.selling_plans || []).forEach(function(sp){
            var txt = (sp.options || []).map(function(o){ return o.value; }).join(' ') + ' ' + sp.name;
            var isMonthly = /חודש/.test(txt) && !/חודשיים|2 חודש|3 חודש|שלוש|ל-2|ל-3/.test(txt);
            if(isMonthly) monthly[sp.id] = true;
          });
        });
        var alloc = p.variants[0].selling_plan_allocations
          .filter(function(a){ return monthly[a.selling_plan_id] && a.per_delivery_price; })
          .sort(function(a, b){ return b.per_delivery_price - a.per_delivery_price; });
        if(alloc.length !== 3) return;
        [1,2,3].forEach(function(q, i){
          SUB[q] = { plan: alloc[i].selling_plan_id, unit: alloc[i].per_delivery_price / 100 };
        });
        render();
        syncMaxClaim();
      })
      .catch(function(){});
  }

  injectStyles();
  cards.forEach(function(c){ paint(c, c.classList.contains('av-is-sel')); });
  stickyBar();
  render();
  syncMaxClaim();
  startCountdown();
  if(SUB99) bindSubProduct(); else bindLegacyPlans();
})();
